angular.module('kareo.ui.shared.directives.pagination', [])
  .controller('kPaginationWidgetController', [
    '$scope', function ($scope) {
      var MAX_LENGTH = 9;
      var MIDDLE = Math.ceil(MAX_LENGTH / 2);
      this.init = function () {
        $scope.pages = [];
        $scope.currentPage = 1;
      };
      $scope.$watch('numberOfPages', () => {
        recalculatePages();
      });
      $scope.$watch('page', (newVal) => {
        if ($scope.currentPage !== newVal) {
          $scope.currentPage = newVal;
          recalculatePages();
        }
      });
      $scope.pageClicked = function (page) {
        if (page > 0 && page <= $scope.numberOfPages && page !== $scope.currentPage) {
          $scope.onClick({ 'selectedValue': page });
          $scope.currentPage = page;
          recalculatePages();
        }
      };
      function recalculatePages() {
        var pArray = [];
        var i = 0;
        if ($scope.numberOfPages > 1) {
          if ($scope.numberOfPages <= MAX_LENGTH) {
            for (i = 0; i < $scope.numberOfPages; i++) {
              pArray[i] = i + 1;
            }
          } else {
            pArray[0] = 1;
            pArray[1] = (($scope.currentPage - MIDDLE) <= 0) ? 2 : '...';
            pArray[MAX_LENGTH - 1] = $scope.numberOfPages;
            pArray[MAX_LENGTH - 2] = (($scope.currentPage + MIDDLE) >= $scope.numberOfPages) ? $scope.numberOfPages - 1 : '...';
            var distanceToLast = $scope.numberOfPages - $scope.currentPage;
            for (i = 2; i < (MAX_LENGTH - 2); i++) {
              if ((MIDDLE - $scope.currentPage) >= 0) {
                pArray[i] = i + 1;
              } else if (distanceToLast <= MIDDLE) {
                pArray[i] = $scope.numberOfPages - MAX_LENGTH + i + 1;
              } else {
                pArray[i] = $scope.currentPage - Math.floor((MAX_LENGTH - 4) / 2) + (i - 2);
              }
            }
          }
        }
        $scope.pages = pArray;
      }
    }])
  .directive('kPaginationWidget', [
    function () {
      function link(scope, element, attrs, kPaginationWidgetController) {
        kPaginationWidgetController.init();
      }

      return {
        restrict: 'E',
        controller: 'kPaginationWidgetController',
        template: require('./pagination-widget.pug')(),
        scope: { numberOfPages: '=', page: '=', onClick: '&' },
        link
      };
    }]);
